module.exports = __webpack_public_path__ + "img/gif5.b7970027.gif";